import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";

export const useSettingsDoc = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/settings").then((r) => setS(r.data));
  }, []);
  const patch = (path, value) => setS((prev) => {
    const next = structuredClone(prev);
    const keys = path.split(".");
    let o = next;
    keys.slice(0, -1).forEach((k) => (o = o[k] ??= {}));
    o[keys[keys.length - 1]] = value;
    return next;
  });
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/settings", s);
      toast.success("تم حفظ التغييرات — تظهر في المتجر مباشرة");
    } catch (e) {
      toast.error(errText(e));
    } finally {
      setBusy(false);
    }
  };
  return { s, setS, patch, save, busy };
};
